type Period = 'day' | 'week';

/** How far back each period starts, counting today as its first day. */
const DAYS_BACK: Record<Period, number> = { day: 0, week: 6 };

/**
 * A period ending now, from midnight on its first day in the phone's own
 * time, as the analytics and performance endpoints take it: today, or the
 * last 7 days.
 */
export function periodSince(period: Period) {
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  start.setDate(start.getDate() - DAYS_BACK[period]);
  return { startDate: start.toISOString(), endDate: new Date().toISOString() };
}
